export default __webpack_public_path__ + "static/media/discord.f965bc6e.svg";